import styled from 'styled-components';
import Ticket from '@widgets/shared/components/icons/Ticket';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
export const Icon = styled(Ticket) `
  margin-right: .5rem;
`;
export const Selection = styled.div `
  ${({ theme: { overviewSelection } }) => overviewSelection}
  
  span {
    display: block;
  }
`;
export const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  padding: 1.5rem 1rem;
  
  ${DummyLink} {
    text-align: center;
  }

  ${({ theme: { overviewWrapper } }) => overviewWrapper}
`;
export default {
    Icon,
    Selection,
    Wrapper,
};
